import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-forgot-password-page',
  templateUrl: './forgot-password-page.component.html',
  // styleUrls: ['./forgot-password-page.component.scss']
})
export class ForgotPasswordPageComponent implements OnInit {

  constructor(private title: Title, private translate: TranslateService) { }

  ngOnInit(): void {
    this.translate.get('title_fortgot_password').subscribe({
      next: (title) => {
        this.title.setTitle(title);
      }
    });
  }

}
